var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const HRWithLabel = (props) => {
    const { className, label } = props, otherProps = __rest(props, ["className", "label"]);
    return (_jsxs("div", Object.assign({}, otherProps, { className: "d-flex align-items-center " + (className || ""), children: [_jsx("div", { className: "border-bottom flex-grow-1" }), _jsx("h6", { className: "mx-3 mb-0", children: label }), _jsx("div", { className: "border-bottom flex-grow-1" })] })));
};
export default HRWithLabel;
